import React from 'react';

/**
 * modules/index.js
 * Autodiscovery system for Madmoco Toolboxes.
 * Automatically scans and registers modules based on manifest.json files.
 * Uses React.lazy for code splitting to optimize performance.
 */

// Use require.context to find all manifests (synchronous metadata)
const manifests_context = require.context('./', true, /manifest\.json$/);

export const autodiscovered_modules = manifests_context.keys().map(path => {
    const manifest = manifests_context(path);

    // Get directory from manifest path (e.g., ./uuid_generator/)
    // path starts with ./ so we keep it for the dynamic import
    const dir = path.substring(0, path.lastIndexOf('/') + 1);
    const componentName = manifest.component || `mmc_${manifest.id}_module`;

    // Extract the relative path without leading ./ for the dynamic import template
    // Webpack needs a hint about where the files are to create chunks
    const relativeDir = dir.replace('./', '');

    // Create a lazy-loaded component
    // Note: We use a dynamic import template. Webpack will create chunks for all matching files.
    const LazyComponent = React.lazy(() => {
        // Try to import .js or .jsx
        // In Webpack require.context environment, we can't easily try extensions inside import()
        // but we can assume the one defined in manifest or the default naming convention
        return import(`./${relativeDir}${componentName}`)
            .catch(err => {
                console.error(`[Autodiscover] Failed to lazy load ${componentName} in ${relativeDir}`, err);
                throw err;
            });
    });

    return { manifest, component: LazyComponent };
});

export default autodiscovered_modules;
